import AboutUsModule from './AboutUsModule';
import AboutUsSiteContainer from './AboutUsSiteContainer';
import styles from './AboutUsImageAndText.module.css';
import { ReactNode } from 'react';

interface PropsForVideo {
  images?: never;
  videoSrc: string;
  videoPoster?: string;
}

interface PropsForImages {
  videoSrc?: never;
  videoPoster?: never;
  images: {
    imagePath: string;
    imageAlt: string;
    verticalFocus?: 'top' | 'center' | 'bottom';
  }[];
}

interface BaseProps {
  children: ReactNode;
  header?: ReactNode;
  /* Whether the image should appear above the header on mobile devices */
  showImageFirstOnMobile?: boolean;
  /* Whether the image(s) should appear on the right on desktop devices */
  imageOnRight?: boolean;
  /* If provided, this element will appear as an overlay above the image/video */
  imageOverlay?: ReactNode;
  background: Parameters<typeof AboutUsModule>[0]['background'];
  objectFit?: 'cover' | 'contain';
  imageSizeDesktop?: 'fixed' | 200;
  imageNoMinHeight?: boolean;
}

type Props = BaseProps & (PropsForImages | PropsForVideo);

const AboutUsImageAndText = (props: Props) => (
  <AboutUsModule background={props.background}>
    <AboutUsSiteContainer>
      <div
        className={
          styles.container +
          ' ' +
          (props.imageOnRight ? styles.containerImageOnRight : '') +
          ' ' +
          (props.imageSizeDesktop && props.imageSizeDesktop != 'fixed'
            ? styles['imageSize__' + props.imageSizeDesktop]
            : '')
        }
      >
        {props.showImageFirstOnMobile ? (
          <>
            {renderImages(props)}
            {renderHeader(props)}
          </>
        ) : (
          <>
            {renderHeader(props)}
            {renderImages(props)}
          </>
        )}
        <div className={styles.textContainer}>{props.children}</div>
      </div>
    </AboutUsSiteContainer>
  </AboutUsModule>
);

function renderHeader(props: Props) {
  return <div className={styles.headerContainer}>{props.header}</div>;
}
function renderImages(props: Props) {
  if (typeof props.videoSrc === 'string') {
    return (
      <div
        className={
          styles.videoContainer +
          ' ' +
          (props.imageNoMinHeight ? styles.noMinHeight : '')
        }
      >
        <div className={styles.video}>
          <video
            className={
              props.objectFit === 'contain' ? styles.objectFitContain : ''
            }
            controls
            poster={props.videoPoster}
          >
            <source src={props.videoSrc} />
          </video>
        </div>
        {props.imageOverlay && (
          <div className={styles.imageOverlay}>{props.imageOverlay}</div>
        )}
      </div>
    );
  }
  return (
    <div
      className={
        styles.imageContainer +
        ' ' +
        (props.images.length > 2
          ? styles.imageContainerWithMultipleImages
          : '') +
        ' ' +
        (props.imageNoMinHeight ? styles.noMinHeight : '')
      }
    >
      {props.images.map((x, index) => (
        <div key={index} className={styles.image}>
          <img
            className={
              (x.verticalFocus
                ? styles['imageFocus__' + x.verticalFocus]
                : '') +
              ' ' +
              (props.objectFit === 'contain' ? styles.objectFitContain : '')
            }
            src={x.imagePath}
            alt={x.imageAlt}
          />
        </div>
      ))}
      {props.imageOverlay && (
        <div className={styles.imageOverlay}>{props.imageOverlay}</div>
      )}
    </div>
  );
}

export default AboutUsImageAndText;
